export const API_BASE_URL = "https://pasaportehaciaelempleo.islacristina.org/api";
export const BASE_URL = "https://pasaportehaciaelempleo.islacristina.org";
export const API_usuarios = API_BASE_URL + "/users";
export const API_ciudadanos = API_BASE_URL + "/ciudadanos";
export const API_tecnicos = API_BASE_URL + "/tecnicos";
export const API_ADMIN = API_BASE_URL + "/admin";
export const API_citas = API_BASE_URL + "/citas";
export const API_empleos = API_BASE_URL + "/jobOffers";
export const API_recursos = API_BASE_URL + "/recursos";
export const API_cursos = API_BASE_URL + "/cursos";
export const API_programas = API_BASE_URL + "/programasSociales";
export const API_servicios = API_BASE_URL + "/serviciosAyuntamiento";
export const API_catalogos = API_BASE_URL + "/catalogs";
